<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>Collections</h1>
      <v-divider></v-divider>
      <Notification :notify="notify" />
      <UploadingStatus ref="uploadingStatus" />
      <div class="row" v-show="!isEdit">
        <div class="pl-3 col">
          <v-text-field
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
            id="Search"
          ></v-text-field>
        </div>
        <div class="col">
          <div class="float-right">
            <v-btn color="primary" @click="onNew()" class="mt-4" id="btnNew">
              New Collection
            </v-btn>
          </div>
        </div>
      </div>
      <v-form ref="form" v-model="valid" lazy-validation>
        <div v-show="isEdit">
          <div class="row">
            <div class="col">
              <v-text-field
                v-model="selectedObj.Name"
                :rules="nameRules"
                label="Collection Name*"
                id="name"
                required
              ></v-text-field>
            </div>
            <div class="col">
              <v-text-field
                v-model="selectedObj.Description"
                :rules="descriptionRules"
                id="description"
                label="Collection Description"
                required
              ></v-text-field>
            </div>
          </div>

          <div class="row">
            <!-- <div class="col">
              <v-text-field
                v-model="selectedObj.Price"
                label="Price"
                type="number"
                required
                :rules="priceRules"
              ></v-text-field>
            </div> -->
            <div class="col">
              <v-checkbox
                v-model="selectedObj.isCoreCollection"
                id="isCollection"
                label="Is Core Collection"
              ></v-checkbox>
              <!-- 
              <v-text-field
                v-model="selectedObj.Seat"
                label="No Of Seats"
                type="number"
                required
                :rules="seatRules"
              ></v-text-field> -->
            </div>
            <div class="col">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-width="200"
                id="cardCollection"
                offset-x
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="indigo" dark v-bind="attrs" v-on="on" plain id="btnCollection">
                    Selected Items For Collection - ( {{ cartItems.length }} )
                  </v-btn>
                </template>

                <v-card>
                  <v-data-table
                    :headers="cartTableHeader"
                    :items="cartItems"
                    hide-default-footer
                    :page.sync="cart_page"
                    :items-per-page="cart_itemsPerPage"
                    @page-count="cart_pageCount = $event"
                    height="500"
                  >
                    <template v-slot:item.Action="{ item }">
                      <div>
                        <v-btn
                          icon
                          color="pink"
                          @click="removeFromCart(item.id)"
                          id="btnRemoveCart"
                        >
                          <v-icon>mdi-close-circle-outline</v-icon>
                        </v-btn>
                      </div>
                    </template>
                  </v-data-table>
                  <v-pagination
                    v-model="cart_page"
                    :length="cart_pageCount"
                  ></v-pagination>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="menu = false" id="btnClose">
                      Close
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </div>
          </div>

          <!-- 
          <div class="row" v-show="false">
            <div class="col">
              <v-combobox
                v-model="selectedObj.publications"
                :items="publications"
                :search-input.sync="searchUser"
                item-text="Title"
                item-value="id"
                hide-selected
                hide-no-data
                dense
                label="Add Publication to the collection"
                multiple
                persistent-hint
                chips
                return-object
                deletable-chips
                @change="onChangeUsers"
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>
            </div>
          </div>-->

          <div class="row mt-5">
            <div class="col">
              <v-card>
                <div class="row">
                  <div class="col-5 ml-5">
                    <v-text-field
                      id="SearchPublication"
                      v-model="SearchPublication"
                      label="Search"
                    ></v-text-field>
                  </div>
                  <div class="col-6 text-right">
                    <div class="row">
                      <div class="col">
                        <v-btn
                          id="downloadpublication"
                          color="primary"
                          @click="onDownloadPublications()"
                          class="mt-4"
                        >
                          <v-icon left>mdi-file-delimited-outline</v-icon>Download Publications</v-btn
                        >
                      </div>
                      <div class="col">
                        <v-file-input
                          ref="dataUpload"
                          id="dataUpload"
                          accept=".csv"
                          placeholder="Upload a csv file"
                          prepend-icon="mdi-file-excel"
                          label="Data Upload"
                          @change="onDataUpload"
                        ></v-file-input>
                      </div>
                    </div>
                  </div>
                </div>
                <v-divider></v-divider>

                <div style="height: 350px; overflow-y: scroll">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <!-- <th class="text-left" style="width: 50px"></th> -->
                        <th class="text-left">Title</th>
                        <th class="text-left">ISBN</th>
                        <th class="text-left">Publisher</th>
                        <th class="text-left">Action</th>
                        <th></th>
                      </thead>
                      <tbody>
                        <tr v-for="item in resultQuery" :key="item.id" :id="'collection' + item.id">
                          <td>{{ item.Title }}</td>
                          <td>{{ item.ISBN }}</td>
                          <td>{{ item.PublisherName }}</td>
                          <td>
                            <div>
                              <v-btn
                                :id="'btnAddNew' + item.id"
                                icon
                                v-if="isAdded(item)"
                                @click="addToCart(item)"
                              >
                                <v-icon>mdi-plus</v-icon>
                              </v-btn>
                              <v-icon v-else color="green">mdi-checkbox-marked-circle</v-icon>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
              </v-card>
              <br />
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="float-right">
                <v-btn @click="onCancel()" id="btnCancel"> Cancel </v-btn>
                <v-btn
                  id="btnSave"
                  class="mr-4"
                  color="primary"
                  @click="onSave()"
                  :loading="loading"
                  :disabled="loading"
                >
                  Save
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </v-form>

      <div class="row" v-show="!isEdit">
        <div class="col">
          <ConfirmationDialog ref="confirm" />
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Name</th>
                  <th class="text-left">Description</th>
                  <!--<th class="text-left">Organization</th>-->
                  <th class="text-left" style="width: 150px">
                    Is Core Collection
                  </th>
                  <!-- <th style="width: 100px">Price</th> -->
                  <!--  <th style="width: 100px">No of Seat</th> -->
                  <th style="width: 100px" class="ml-10"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id" :id="'collection' + i">
                  <td>{{ item.Name }}</td>
                  <td>{{ item.Description }}</td>
                  <!--<td> {{ item.OrganizationName }}</td>-->
                  <td>
                    <v-checkbox
                      v-model="item.isCoreCollection"
                      readonly
                      :id="'coreCollection' + i"
                    ></v-checkbox>
                  </td>
                  <!-- <td class="text-right">{{ item.Price }}</td> -->
                  <!--   <td class="text-right">{{ item.Seat }}</td> -->
                  <td>
                    <v-icon class="mr-2 icon-edit" @click="onEdit(item)"
                      >mdi-comment-edit</v-icon
                    >
                    <v-icon class="mr-2 icon-delete" @click="onDelete(item)"
                      >mdi-delete</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row" v-show="!isEdit">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </div>
      </div>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>
<script>
import lodash from "lodash";
import csv from 'csvtojson';
import { Parser } from "json2csv";
import fileUploadService from "../api/fileUploadService";
import Notification from "@/components/Notification";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Pagination from "@/components/Pagination";
import * as api from "@/api";
import UploadingStatus from "../components/UploadingStatus.vue";

export default {
  name: "Collection",
  components: {
    Notification,
    ConfirmationDialog,
    Pagination,
    UploadingStatus
  },
  created() {
    this.getCollectionByPagin();
    this.getPublication();
    this.getUserCollections();
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    resultQuery() {
      if (this.SearchPublication) {
        return this.publications.filter(item => {
          return this.SearchPublication.toLowerCase()
            .split(" ")
            .every(
              v =>
                item.Title.toLowerCase().includes(v) ||
                item.ISBN.toLowerCase().includes(v) ||
                item.PublisherName.toLowerCase().includes(v)
            );
        });
      } else {
        return this.publications;
      }
    }
  },
  methods: {
    onNew() {
      this.isEdit = true;
      this.selectedObj.id = 0;
      this.selectedObj.Name = "";
      this.selectedObj.Description = "";
      this.selectedObj.publications = [];
      this.selectedObj.Price = 0;
      this.selectedObj.Seat = 0;
      this.selectedObj.isCoreCollection = false;
      this.selectedObj.collectionType = 1;
      this.$refs.form.reset();
      this.cartItems.splice(0, this.cartItems.length);
    },
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getCollectionByPagin();
    },
    onSave() {
      let that = this;
      this.notify.type = 0;
      this.notify.errors = [];

      console.log(that.cartItems);

      for (let i = 0; i < that.cartItems.length; i++) {
        let obj = Object.assign({}, that.cartItems[i]);
        this.selectedObj.publications.push(obj);
      }

      if (this.selectedObj.isCoreCollection == null) {
        this.selectedObj.isCoreCollection = false;
      }

      this.selectedObj.collectionType = 1
       
      console.log(this.selectedObj);
      this.$refs.form.validate();

      if (this.selectedObj.Description == null || this.selectedObj.Description.length < 1 || !this.valid) return;

      if (this.selectedObj.publications.length == 0) {
        this.notify.type = 4;
        this.notify.errors.push("Please add publications.");
        return;
      }
      this.loading = true;
      that.overlay = true;
      new Promise((resolve, reject) => {
        api
          .update("collection", this.selectedObj)
          .then(response => {
            if (response.status === 200 || response.status === 201) {
              this.notify.type = 1;
              this.notify.message =
                this.selectedObj.id === -1
                  ? "Record successfully saved."
                  : "Record successfully updated.";
              this.loading = false;
              this.isEdit = false;
              this.cartItems = [];
              this.getCollectionByPagin();
              setTimeout(() => {
                this.notify.type = 0;
              }, 3000);
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data.");
              this.loading = false;
            }
            resolve(response);
            that.overlay = false;
          })
          .catch(error => {
            that.overlay = false;
            console.log(error);
            if (error.response.status == 409) {
              this.notify.type = 4;
              this.notify.errors.push("Collections name already exist");
              this.loading = false;
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              this.loading = false;
            }
            reject(error);
          });
      });
    },
    onEdit(obj) {
      this.isEdit = true;
      this.selectedObj = Object.assign({}, obj);
      this.getPublicationCollection(obj.id);
    },
    async onDelete(obj) {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to delete this record?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .DeleteByID("collection", obj.id)
            .then(response => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message = "Record successfully deleted";
                this.getCollectionByPagin();
                setTimeout(() => {
                  this.notify.type = 0;
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch(error => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }
    },
    onCancel() {
      this.isEdit = false;
    },
    getCollections() {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getAll("collection")
          .then(response => {
            console.log(response);
            this.list = response.data;
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    onNextPage(page) {
      console.log("onNextPage " + page);
      this.paging.page = page;
      this.paging.keyword = this.Search;
      console.log(this.paging);

      this.getCollectionByPagin();
    },
    getCollectionByPagin() {
      let that = this;
      that.overlay = true;
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin("collection", this.paging)
          .then(response => {
            console.log(response);
            this.paging.count = response.data.count;
            this.list = response.data.data;
            that.overlay = false;
          })
          .catch(error => {
            that.overlay = false;
            reject(error);
          });
      });
    },
    getUserCollections() {
      new Promise((resolve, reject) => {
        api
          //.getAll("licenses/user-collection/1")  ///api/v1/licenses/opds/collection/{id}
          .getByID("licenses/opds/collection", 1)
          .then(response => {
            console.log(" opds " + response);
          })
          .catch(error => {
            console.log(" opds " + error);
            reject(error);
          });
      });
    },
    getPublication() {
      let that = this;
      that.overlay = true;
      this.users = [];
      new Promise((resolve, reject) => {
        api
          .getAll("publications")
          .then(response => {
            console.log(response);
            this.publications = response.data;

            for (let i = 0; i < this.publications.length; i++) {
              this.publications[i].IsSelected = false;
              if (this.publications[i].PublisherName == null)
                this.publications[i].PublisherName = "";
            }
            that.overlay = false;
          })
          .catch(error => {
            that.overlay = false;
            reject(error);
          });
      });
    },
    getPublicationCollection(id) {
      let that = this;
      that.overlay = true;
      this.selectedObj.publications = [];
      for (let i = 0; i < this.publications.length; i++) {
        this.publications[i].IsSelected = false;
      }
      new Promise((resolve, reject) => {
        api
          .getByID("publication-collection/publication", id)
          .then(response => {
            console.log(response.data);
            that.cartItems.splice(0, that.cartItems.length);
            for (let i = 0; i < response.data.length; i++) {
              var objIndex = that.publications.findIndex(
                p => p.id == response.data[i].id
              );
              that.publications[objIndex].IsSelected = true;
              that.cartItems.push(that.publications[objIndex]);
            }
            that.SearchPublication = " ";
            that.SearchPublication = "";
            that.overlay = false;
          })
          .catch(error => {
            that.overlay = false;
            reject(error);
          });
      });
    },
    onChangeUsers(items) {
      for (let i = 0; i < items.length; i++) {
        if (!(typeof this.selectedObj.publications[i] === "object")) {
          items.splice(i, 1);
          break;
        }
      }
    },
    addToCart(item) {
      let that = this;
      if (lodash.find(that.cartItems, { id: item.id }) == undefined) {
        that.cartItems.push({
          id: item.id,
          Title: item.Title,
          ISBN: item.ISBN,
          Publisher: item.PublisherName,
          Action: item.id
        });
      }
      //that.cartItems.push(Object.assign({}, item));
    },
    removeFromCart(item) {
      let index = lodash.findIndex(this.cartItems, { id: item });
      if (index !== -1) {
        this.cartItems.splice(index, 1);
      }
    },
    isAdded(item) {
      let that = this;
      if (lodash.find(that.cartItems, { id: item.id }) == undefined) {
        return true;
      } else {
        return false;
      }
    },
    onDownloadPublications() {
      api.getAll("publications").then((response) => {
        this.exportData = response.data;
        this.downloadPublicationMetadataAsCSV(this.exportData);
      });
    },
    downloadPublicationMetadataAsCSV(json) {
      const parser = new Parser();
      const csv = parser.parse(
        json.map((pub) => this.mapPublicationMetadataToCSVRecord(pub))
      );

      var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

      var link = document.createElement("a");
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "publications-metadata.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    mapPublicationMetadataToCSVRecord(pub) {
      return {
        id: pub.id || "",
        Title: pub.Title || "",
        ISBN: pub.ISBN || "",
        "Publisher Name": pub.PublisherName || "",
        "Include in Collection": false,
      };
    },
    async onDataUpload(file) {
      if (this._uploading) return;
      this._uploading = true;

      this.overlay = true;
      
      if (!file) {
        this.overlay = false;
        this._uploading = false;
        return;
      }

      const confirmed = await this.$refs.confirm.open(
        "Confirm",
        "Are you sure you want to upload this file?"
      );

      if (!confirmed) {
        this.overlay = false;
        const input = this.$refs.dataUpload.$el.querySelector('input');
        if (input) input.value = null;
        this.$refs.dataUpload.reset();
        this._uploading = false;
        return;
      }

      try {
        const content = await fileUploadService.uploadFileReader(file);
        const uploadContent = await this.CsvToJson(content);
        const payloadContent = [];
        const validations = [];

        for (const item of uploadContent) {
            let isValid = true;
            const includeInCollection = item["Include in Collection"].toLocaleLowerCase() === 'true' ? true : item["Include in Collection"].toLocaleLowerCase() === 'false' ? false : item["Include in Collection"];
            if (!this.isColumnNotEmpty(includeInCollection)) {
              validations.push({Title: item.Title, ISBN: item.ISBN, PublisherName: item["Publisher Name"], Message: `"Include in Collection" column should be a True or False`, isSuccess: false  });
              isValid = false;
            }
            if (isValid && includeInCollection === true) {
              payloadContent.push({
                id: Number(item.id) || "",
                Title: item.Title || "",
                ISBN: item.ISBN || "",
                PublisherName: item["Publisher Name"] || "",
                IsSelected: true,
              });
              validations.push({Title: item.Title, ISBN: item.ISBN, PublisherName: item["Publisher Name"], Message: `Added to Collection`, isSuccess: true  });
            } else if (isValid && includeInCollection === false) {
              payloadContent.push({
                id: Number(item.id) || "",
                Title: item.Title || "",
                ISBN: item.ISBN || "",
                PublisherName: item["Publisher Name"] || "",
                IsSelected: false,
              });
              validations.push({Title: item.Title, ISBN: item.ISBN, PublisherName: item["Publisher Name"], Message: `Not added to Collection`, isSuccess: true  });
            }
        }

        this.loading = true;

        if (payloadContent.length > 0) {
          for (const payloadItem of payloadContent) {
            if (payloadItem.IsSelected) {
              this.addToCart(payloadItem);
            } else {
              this.removeFromCart(payloadItem.id);
            }
          }
          this.$refs.uploadingStatus.open(validations);
        } else {
          this.$refs.uploadingStatus.open(validations);
        }
      } catch (error) {
        this.notify.type = 4;
        this.notify.errors.push("Failed to upload data. " + error);
      } finally {
        this.loading = false;
        this.overlay = false;
        const input = this.$refs.dataUpload.$el.querySelector('input');
        if (input) input.value = null;
        this.$refs.dataUpload.reset();
        this._uploading = false;
      }
    },
    async CsvToJson(content) {
      return new Promise((resolve,reject)=> {
        csv({
            noheader:false,
            output: "json",
            quote: '"',
            flatKeys: false,
            downstreamFormat: true
        }).fromString(content)
        .then((csvRow)=>{ 
            resolve(csvRow);
        })
      });    
    },
    isColumnNotEmpty(value) {
      if (typeof value !== 'boolean') {
        return false;
      }
      return true;
    },
  },
  data() {
    return {
      list: [],
      publications: [],
      isEdit: false,
      isNew: false,
      Search: "",
      SearchPublication: "",
      searchUser: null,
      selectedObj: { isCoreCollection: false },
      selectedCollection: [],
      notify: {
        type: 0,
        message: "",
        errors: []
      },
      valid: true,
      nameRules: [v => !!v || "Collection name is required"],
      descriptionRules: [v => !!v || "Collection description is required"],
      loading: false,
      paging: {
        count: 10,
        page: 1,
        size: 10,
        keyword: "",
        orderColumn: "Id",
        isASC: false
      },
      priceRules: [v => !!v || "Price is required"],
      seatRules: [v => !!v || "Seat is required"],
      overlay: false,
      cartTableHeader: [
        {
          text: "Title",
          align: "start",
          sortable: false,
          value: "Title"
        },
        {
          text: "ISBN",
          align: "start",
          sortable: false,
          value: "ISBN"
        },
        {
          text: "Publisher",
          align: "start",
          sortable: false,
          value: "Publisher"
        },
        {
          text: "Action",
          align: "start",
          sortable: false,
          value: "Action"
        }
      ],
      cartItems: [],
      fav: true,
      menu: false,
      message: false,
      hints: true,
      cart_page: 1,
      cart_pageCount: 0,
      cart_itemsPerPage: 10
    };
  }
};
</script>
<style scoped>
.icon-edit {
  color: #1975d2;
}
.icon-delete {
  color: red;
}
.col {
  padding: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/Collection.vue